<template>
  <div v-if="pickings && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="pickings" />
  </div>
</template>
<script>
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";
import Waves from "@/api/waves";
import i18n from "@/i18n";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    pickings: {},
  }),

  mounted() {
    PrintTemplates.fetchOne("wavePicking").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;
          Waves.pickingPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.pickings = response.data;
                var details = [];
                this.pickings.pick_details.forEach((detail) => {
                  if (detail.pick_details.length) {
                    detail.pick_details.forEach((d) => {
                      details.push(
                        Object.assign({}, d, {
                          material_bar_code: detail.material_bar_code,
                          category_name: detail.category_name,
                          standard_name: detail.standard_name,
                          material_name: detail.material_name,
                          storage_conditions: detail.storage_conditions,
                        })
                      );
                    });
                  } else {
                    details.push({
                      material_bar_code: detail.material_bar_code,
                      category_name: detail.category_name,
                      standard_name: detail.standard_name ? (detail.standard_name.length > 12 ? detail.standard_name.slice(0, 12) + "......" : detail.standard_name) : "",
                      material_name: detail.material_name,
                      storage_conditions: detail.storage_conditions,
                      pick_stock_num: i18n.t("Wave.actions.outStock"),
                    });
                  }
                });
                this.pickings = Object.assign({}, this.pickings, {
                  pick_details: details,
                });
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>